// import { Eye } from 'lucide-react';
// import { useState } from 'react';
// import owlImage from '../../../assets/GradingOwlCropped.png';
// import GoogleIconPath from '../../../assets/google.svg';
// const AppleLogoSVG = () => (
//   <svg viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg" className="h-5 w-auto mb-[2px]">
//     <path
//       d="M5.74714 21.501C5.73714 21.501 5.72714 21.501 5.70714 21.501C4.02714 21.491 2.82714 19.9811 1.97714 18.6711C-0.192861 15.3411 -0.632862 11.151 0.937138 8.72104C1.98714 7.09104 3.68714 6.08103 5.36714 6.08103C6.23714 6.08103 6.91714 6.32105 7.51714 6.54105C7.99714 6.71105 8.40714 6.86103 8.83714 6.86103C9.21714 6.86103 9.54714 6.73105 9.96714 6.57105C10.5471 6.35105 11.2571 6.08103 12.2871 6.08103C13.7671 6.08103 15.2871 6.87103 16.3471 8.21103C16.4871 8.38103 16.5371 8.61105 16.4971 8.82105C16.4571 9.04105 16.3171 9.22103 16.1271 9.33103C14.9971 9.95103 14.3771 11.081 14.4671 12.361C14.5571 13.661 15.3571 14.761 16.5571 15.211C16.7471 15.281 16.9071 15.431 16.9871 15.621C17.0671 15.811 17.0671 16.031 16.9771 16.211C16.5371 17.191 16.3171 17.641 15.7471 18.521C14.7971 19.981 13.5971 21.481 11.9571 21.501C11.2471 21.501 10.7671 21.291 10.3471 21.091C9.92714 20.901 9.51714 20.7511 8.86714 20.7311C8.16714 20.7311 7.79714 20.901 7.36714 21.091C6.92714 21.291 6.44714 21.501 5.74714 21.501ZM5.36714 7.58103C4.18714 7.58103 2.97714 8.33104 2.19714 9.53104C1.13714 11.171 1.14714 14.641 3.23714 17.851C3.88714 18.851 4.75714 19.991 5.72714 20.001C6.08714 19.991 6.35714 19.8911 6.72714 19.7311C7.21714 19.5111 7.82714 19.2411 8.83714 19.2311C9.82714 19.2111 10.4671 19.5011 10.9571 19.7311C11.3171 19.9011 11.5571 20.011 11.9271 20.001C12.8671 19.991 13.7771 18.771 14.4771 17.711C14.8471 17.141 15.0571 16.781 15.2871 16.271C13.9471 15.481 13.0671 14.091 12.9571 12.471C12.8471 10.941 13.4671 9.51104 14.6071 8.56104C13.9071 7.94104 13.0771 7.59104 12.2771 7.59104C11.5271 7.59104 11.0271 7.78105 10.4971 7.98105C9.99714 8.17105 9.47714 8.37104 8.82714 8.37104C8.13714 8.37104 7.56714 8.16104 7.00714 7.97104C6.47714 7.76104 5.96714 7.58103 5.36714 7.58103ZM8.33714 5.88105C8.30714 5.88105 8.26714 5.88105 8.23714 5.88105C7.88714 5.87105 7.58714 5.61105 7.52714 5.26105C7.31714 4.13105 7.71714 2.83103 8.58714 1.77103C9.38714 0.801031 10.7071 0.0810415 11.8771 0.00104151C12.2871 -0.0189585 12.6171 0.251056 12.6671 0.641056C12.8371 1.81106 12.4671 3.09104 11.6371 4.16105C10.8271 5.21105 9.53714 5.88105 8.33714 5.88105ZM11.1671 1.70105C10.6271 1.92105 10.0971 2.29104 9.74714 2.72104C9.41714 3.12104 9.10714 3.68105 9.00714 4.26105C9.54714 4.08105 10.0871 3.72103 10.4571 3.24103C10.6571 2.99103 11.0371 2.41105 11.1671 1.70105Z"
//       fill="white"
//     />
//   </svg>
// );

// export default function LoginPage({ onLoginSuccess }: { onLoginSuccess: () => void }) {
//   const [isPasswordVisible, setIsPasswordVisible] = useState(false);

//   const handleFakeLogin = () => {
//     localStorage.setItem('dummy_auth_token', 'true');
//     if (onLoginSuccess) {
//       onLoginSuccess();
//     }
//   };

//   return (
//     <div className="flex min-h-screen w-full bg-white">
//       <div className="flex w-full flex-col justify-center px-8 py-12 md:w-1/2 lg:px-20 xl:px-24 relative">
//         <div className="absolute top-10 left-8 lg:left-20">
//           <h2 className="text-xl font-bold text-[brand-200] font-['Futura',_sans-serif]">gradias</h2>
//         </div>

//         <div className="w-full max-w-sm mx-auto mt-12">
//           <h1 className="text-4xl font-bold text-[var(--color-slate-700)] mb-2">Sign In</h1>
//           <p className="text-[var(--color-slate-700)] mb-8">
//             or create an account{' '}
//             <a href="/signup" className="underline hover:text-slate-700">
//               here
//             </a>
//           </p>

//           <form className="space-y-6" onSubmit={e => e.preventDefault()}>
//             <div>
//               <label className="block text-sm font-medium text-slate-700 mb-1">E-Mail</label>
//               <input
//                 type="email"
//                 placeholder="gradi@school.com"
//                 className="block w-full rounded-lg border border-slate-300 px-4 py-3 text-slate-900 focus:border-brand-500 focus:ring-brand-500 focus:outline-none sm:text-sm"
//               />
//             </div>

//             <div>
//               <label className="block text-sm font-medium text-slate-700 mb-1">Password</label>
//               <div className="relative">
//                 <input
//                   type={isPasswordVisible ? 'text' : 'password'}
//                   placeholder="?#_:%@"
//                   className="block w-full rounded-lg border border-slate-300 px-4 py-3 text-slate-900 focus:border-brand-500 focus:ring-brand-500 focus:outline-none sm:text-sm"
//                 />
//                 <button
//                   type="button"
//                   onClick={() => setIsPasswordVisible(!isPasswordVisible)}
//                   className="absolute right-3 top-3 text-slate-400"
//                 >
//                   <Eye className="h-5 w-5" />
//                 </button>
//               </div>
//             </div>

//             <div className="flex items-center justify-between">
//               <div className="flex items-center">
//                 <input type="checkbox" className="h-4 w-4 rounded border-slate-300 text-brand-500" />
//                 <label className="ml-2 block text-sm text-slate-400">Remember me</label>
//               </div>
//               <div className="text-sm">
//                 <a href="/forgot-password" className="font-bold text-slate-700 hover:text-slate-900 underline">
//                   Forgot Password?
//                 </a>
//               </div>
//             </div>

//             <button
//               onClick={handleFakeLogin}
//               className="flex w-full justify-center rounded-lg bg-[brand-200] px-4 py-3 text-sm font-semibold text-white hover:bg-[brand-400]"
//             >
//               Sign In
//             </button>
//           </form>

//           <div className="relative mt-8 mb-8">
//             <div className="absolute inset-0 flex items-center">
//               <div className="w-full border-t border-slate-300" />
//             </div>
//             <div className="relative flex justify-center">
//               <span className="bg-white px-2 text-sm text-slate-500">or</span>
//             </div>
//           </div>

//           <div className="flex flex-col gap-3">
//             <button
//               onClick={handleFakeLogin}
//               className="flex w-full items-center justify-center gap-3 rounded-lg border border-slate-300 bg-white px-4 py-3 text-sm font-semibold text-slate-700 hover:bg-slate-50 transition-colors"
//             >
//               <img src={GoogleIconPath} alt="Google" className="h-5 w-5" />
//               Continue with Google
//             </button>

//             <button
//               onClick={handleFakeLogin}
//               className="flex w-full items-center justify-center gap-3 rounded-lg bg-[var(--color-slate-700)] px-4 py-3 text-sm font-semibold text-white hover:bg-[var(--color-slate-800)] transition-colors"
//             >
//               <AppleLogoSVG />
//               Continue with Apple
//             </button>
//           </div>
//         </div>
//       </div>

//       <div className="hidden w-2/3 flex-col bg-[brand-200] p-[4%] text-white md:flex relative overflow-hidden h-100vh">
//         <div
//           className="absolute top-0 right-0 w-[60vw] h-[60vw] rounded-full translate-x-1/2 -translate-y-1/2 pointer-events-none"
//           style={{ background: 'radial-gradient(circle, var(--color-brand-500)c0 0%, var(--color-brand-100)b9 50%, var(--color-brand-200)36 100%)' }}
//         />
//         <div className="flex-1 w-full flex items-center justify-center min-h-0 z-10">
//           <div className="bg-white w-full max-h-[90%] aspect-[1.6] rounded-[2.5vw] relative flex flex-col p-[6%]">
//             <div className="flex-1 w-full flex justify-end items-start min-h-0 mb-[2%]">
//               <img src={owlImage} alt="Grading Owl" className="h-full w-auto object-contain object-right-top" />
//             </div>
//             <div className="w-[85%] shrink-0">
//               <p className="text-[brand-200] font-bold leading-tight" style={{ fontSize: '1.6vw' }}>
//                 Reliable AI-based exam grading that turns hours of correction into minutes.
//               </p>
//             </div>
//           </div>
//         </div>
//         <div className="w-full text-right shrink-0 pt-1 z-10">
//           <h2 className="font-bold leading-tight" style={{ fontSize: '3vw' }}>
//             Grade wisely.
//             <br />
//             Teach more.
//           </h2>
//         </div>
//       </div>
//     </div>
//   );
// }

import { loginWithOAuth } from '@adornis/authentication/oauth-client/client/loginWithOAuth.js';
import { logger } from '@adornis/base/logging.js';
import { subscribeCurrentUser } from '@adornis/users/client/currentUser.js';
import { login } from '@adornis/users/client/loginFunctions.js';
import { useState } from 'react';
import { router } from '../../../App.js';
import OwlLogo from '../../../assets/OwlTransparent.svg';
import GoogleIconPath from '../../../assets/google.svg';
import LabeledInput, { validateInput } from '../../../components/ui/labeled-inputs.js';
import { getGuestConversationId } from '../../../lib/guest-user-id.js';

const AppleLogoSVG = () => (
  <svg viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg" className="h-5 w-auto mb-[2px]">
    <path
      d="M5.74714 21.501C5.73714 21.501 5.72714 21.501 5.70714 21.501C4.02714 21.491 2.82714 19.9811 1.97714 18.6711C-0.192861 15.3411 -0.632862 11.151 0.937138 8.72104C1.98714 7.09104 3.68714 6.08103 5.36714 6.08103C6.23714 6.08103 6.91714 6.32105 7.51714 6.54105C7.99714 6.71105 8.40714 6.86103 8.83714 6.86103C9.21714 6.86103 9.54714 6.73105 9.96714 6.57105C10.5471 6.35105 11.2571 6.08103 12.2871 6.08103C13.7671 6.08103 15.2871 6.87103 16.3471 8.21103C16.4871 8.38103 16.5371 8.61105 16.4971 8.82105C16.4571 9.04105 16.3171 9.22103 16.1271 9.33103C14.9971 9.95103 14.3771 11.081 14.4671 12.361C14.5571 13.661 15.3571 14.761 16.5571 15.211C16.7471 15.281 16.9071 15.431 16.9871 15.621C17.0671 15.811 17.0671 16.031 16.9771 16.211C16.5371 17.191 16.3171 17.641 15.7471 18.521C14.7971 19.981 13.5971 21.481 11.9571 21.501C11.2471 21.501 10.7671 21.291 10.3471 21.091C9.92714 20.901 9.51714 20.7511 8.86714 20.7311C8.16714 20.7311 7.79714 20.901 7.36714 21.091C6.92714 21.291 6.44714 21.501 5.74714 21.501ZM5.36714 7.58103C4.18714 7.58103 2.97714 8.33104 2.19714 9.53104C1.13714 11.171 1.14714 14.641 3.23714 17.851C3.88714 18.851 4.75714 19.991 5.72714 20.001C6.08714 19.991 6.35714 19.8911 6.72714 19.7311C7.21714 19.5111 7.82714 19.2411 8.83714 19.2311C9.82714 19.2111 10.4671 19.5011 10.9571 19.7311C11.3171 19.9011 11.5571 20.011 11.9271 20.001C12.8671 19.991 13.7771 18.771 14.4771 17.711C14.8471 17.141 15.0571 16.781 15.2871 16.271C13.9471 15.481 13.0671 14.091 12.9571 12.471C12.8471 10.941 13.4671 9.51104 14.6071 8.56104C13.9071 7.94104 13.0771 7.59104 12.2771 7.59104C11.5271 7.59104 11.0271 7.78105 10.4971 7.98105C9.99714 8.17105 9.47714 8.37104 8.82714 8.37104C8.13714 8.37104 7.56714 8.16104 7.00714 7.97104C6.47714 7.76104 5.96714 7.58103 5.36714 7.58103ZM8.33714 5.88105C8.30714 5.88105 8.26714 5.88105 8.23714 5.88105C7.88714 5.87105 7.58714 5.61105 7.52714 5.26105C7.31714 4.13105 7.71714 2.83103 8.58714 1.77103C9.38714 0.801031 10.7071 0.0810415 11.8771 0.00104151C12.2871 -0.0189585 12.6171 0.251056 12.6671 0.641056C12.8371 1.81106 12.4671 3.09104 11.6371 4.16105C10.8271 5.21105 9.53714 5.88105 8.33714 5.88105ZM11.1671 1.70105C10.6271 1.92105 10.0971 2.29104 9.74714 2.72104C9.41714 3.12104 9.10714 3.68105 9.00714 4.26105C9.54714 4.08105 10.0871 3.72103 10.4571 3.24103C10.6571 2.99103 11.0371 2.41105 11.1671 1.70105Z"
      fill="currentColor"
    />
  </svg>
);

export default function LoginPage() {
  const [showValidation, setShowValidation] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loginError, setLoginError] = useState<string | null>(null);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setLoginError(null);
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setShowValidation(true);
    setLoginError(null);

    if (!validateInput(formData.email, 'email') || !formData.password.trim()) {
      return;
    }

    setIsSubmitting(true);
    try {
      await login(formData.email, formData.password);
      // After successful login, re-subscribe to update the currentUser observable
      await subscribeCurrentUser();
      // The AuthGuard in App.tsx will automatically show the app now
    } catch (err: any) {
      logger.error(err, `Login failed:`);
      setLoginError(err?.message || 'Login fehlgeschlagen. Bitte überprüfe deine Eingaben.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleGoogleSignIn = () => {
    const guestConversationId = getGuestConversationId();
    const successRedirect = new URL('/', window.location.origin);

    if (guestConversationId) {
      successRedirect.searchParams.set('guestConversationId', guestConversationId);
    }

    loginWithOAuth({ successRedirect: successRedirect.toString() });
  };

  return (
    <div className="min-h-screen bg-white dark:bg-background flex relative">
      {/* Logo text – pinned top-left */}
      <div className="hidden lg:block absolute top-8 left-8 z-10">
        <h1 className="text-2xl font-['Futura'] font-semibold text-brand-500">gradias</h1>
      </div>

      {/* Left Side - Logo (Identisch zur SignUp Page) */}
      <div className="hidden lg:block lg:w-1/4 min-h-screen relative overflow-hidden">
        <img
          src={OwlLogo}
          alt="Gradias Owl Logo"
          className="
            absolute
            top-1/2
            left-0
            -translate-x-1/2
            -translate-y-1/2
            w-[200%]
            h-auto
            max-w-none
            opacity-90
          "
        />
      </div>

      {/* Middle - Form */}
      <div className="w-full lg:w-1/2 flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          {/* Sign In Heading */}
          <h2 className="text-4xl font-bold text-slate-900 dark:text-slate-100 mb-2">Sign In</h2>
          <p className="text-slate-600 dark:text-slate-400 mb-8">
            or create an account{' '}
            <button
              type="button"
              onClick={() => router.goTo('signUp')}
              className="text-brand-500 underline hover:text-[brand-600] font-medium"
            >
              here
            </button>
          </p>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-4">
            {/* E-Mail via LabeledInput */}
            <LabeledInput
              id="email"
              name="email"
              label="E-Mail"
              type="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="gradi@school.com"
              required={true}
              showValidation={showValidation}
            />

            {/* Password via LabeledInput — no format validation on login, just check non-empty */}
            <LabeledInput
              id="password"
              name="password"
              label="Password"
              type="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="?#_:%@"
              required={true}
              showValidation={false}
            />

            {/* Remember me & Forgot Password Row */}
            <div className="flex items-center justify-between pt-2">
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="remember"
                  className="h-4 w-4 rounded border-slate-300 dark:border-slate-600 text-brand-500 focus:ring-brand-500"
                />
                <label htmlFor="remember" className="ml-2 block text-sm text-slate-500 dark:text-slate-400">
                  Remember me
                </label>
              </div>
              <div className="text-sm">
                <a
                  href="/forgot-password"
                  className="font-semibold text-slate-700 dark:text-slate-300 hover:text-brand-500 transition-colors"
                >
                  Forgot Password?
                </a>
              </div>
            </div>

            {/* Error Message */}
            {loginError && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
                {loginError}
              </div>
            )}

            {/* Submit Button */}
            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full bg-brand-500 text-white py-3 rounded-lg font-medium hover:bg-[brand-600] transition-colors mt-6 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isSubmitting ? 'Signing in…' : 'Sign In'}
            </button>
          </form>

          {/* Divider */}
          <div className="relative mt-8 mb-8">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-slate-200 dark:border-slate-700" />
            </div>
            <div className="relative flex justify-center">
              <span className="bg-white dark:bg-background px-3 text-sm text-slate-400 dark:text-slate-500">or</span>
            </div>
          </div>

          {/* Social Logins */}
          <div className="flex flex-col gap-3">
            <button
              type="button"
              onClick={handleGoogleSignIn}
              className="flex w-full items-center justify-center gap-3 rounded-lg border border-slate-300 bg-white px-4 py-3 text-sm font-semibold text-slate-700 hover:bg-slate-50 transition-colors"
            >
              <img src={GoogleIconPath} alt="Google" className="h-5 w-5" />
              Continue with Google
            </button>

            <button
              type="button"
              className="flex w-full items-center justify-center gap-3 rounded-lg bg-[var(--color-slate-700)] px-4 py-3 text-sm font-semibold text-white hover:bg-[var(--color-slate-800)] transition-colors"
            >
              <AppleLogoSVG />
              Continue with Apple (coming soon)
            </button>
          </div>
        </div>
      </div>

      <div className="hidden lg:block lg:w-1/4 min-h-screen relative overflow-hidden">
        <div
          className="absolute bottom-0 right-0 w-[200%] aspect-square translate-x-1/2 translate-y-1/2 rounded-full animate-[spin_30s_linear_infinite]"
          style={{
            background:
              'radial-gradient(circle at 30% 30%, brand-500 0%, brand-200 35%, rgba(137, 180, 214, 0.1) 70%, transparent 100%)',
          }}
        />
      </div>
    </div>
  );
}
